import { getNoteIdFromHash, discussionsContainNote } from '~/notes/utils/note_hash';
import { hasScrolled } from '~/rapid_diffs/utils/scroll_to_linked_fragment';
import DiffGutterToggle from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/diff_gutter_toggle.vue?vue3';
import DiffLineDiscussions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/diff_line_discussions.vue?vue3';
export default {
    name: 'DiffDiscussionRow',
    components: {
        DiffGutterToggle,
        DiffLineDiscussions
    },
    inject: {
        store: {
            type: Object
        },
        filePaths: {
            type: Object
        },
        diffRefs: {
            type: Object,
            default: undefined
        }
    },
    props: {
        oldLine: {
            type: Number,
            required: false,
            default: null
        },
        newLine: {
            type: Number,
            required: false,
            default: null
        },
        parallel: {
            type: Boolean,
            required: true
        },
        changed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'empty',
        'highlight',
        'clear-highlight',
        'start-thread'
    ],
    computed: {
        positions () {
            if (!this.parallel || this.oldLine && this.newLine && !this.changed) {
                return [
                    this.pos(this.oldLine, this.newLine)
                ];
            }
            return [
                this.pos(this.oldLine, null),
                this.pos(null, this.newLine)
            ];
        },
        colspan () {
            if (!this.parallel) return 3;
            return this.positions.length === 1 ? 4 : 2;
        },
        discussionsByPosition () {
            return this.positions.map((p)=>this.store.findLineDiscussionsForPosition({
                    ...p,
                    diffRefs: this.diffRefs
                }));
        },
        regularDiscussionsByPosition () {
            return this.discussionsByPosition.map((discussions)=>discussions.filter((d)=>!d.isDraft));
        },
        allResolved () {
            return this.regularDiscussionsByPosition.every((discussions)=>{
                if (!discussions.length) return true;
                const resolvable = discussions.filter((d)=>!d.isForm && d.resolvable);
                return resolvable.length > 0 && resolvable.every((d)=>d.resolved);
            });
        },
        allHidden () {
            return this.regularDiscussionsByPosition.every((discussions)=>discussions.every((d)=>d.hidden));
        },
        hideableDiscussions () {
            return this.regularDiscussionsByPosition.flat().filter((discussion)=>!discussion.isForm);
        },
        hasDrafts () {
            return this.discussionsByPosition.some((discussions)=>discussions.some((d)=>d.isDraft));
        },
        empty () {
            return this.discussionsByPosition.every((discussions)=>discussions.length === 0);
        },
        editingLineRange () {
            return this.discussionsByPosition.some((discussions)=>discussions.some((discussion)=>discussion.isForm && discussion.editingLineRange));
        }
    },
    watch: {
        empty (value) {
            if (value) this.$emit('empty');
        },
        allResolved (resolved) {
            this.setHidden(resolved);
        }
    },
    mounted () {
        this.expandDiscussionForNoteFragment();
    },
    methods: {
        expandDiscussionForNoteFragment () {
            if (hasScrolled()) return;
            const noteId = getNoteIdFromHash();
            if (!noteId) return;
            for (const position of this.positions){
                if (discussionsContainNote(this.store.findLineDiscussionsForPosition({
                    ...position,
                    diffRefs: this.diffRefs
                }), noteId)) {
                    this.setHidden(false);
                    return;
                }
            }
        },
        pos (oldLine, newLine) {
            const { oldPath, newPath } = this.filePaths;
            return {
                oldPath,
                newPath,
                oldLine,
                newLine
            };
        },
        discussionsForGutter (index) {
            return this.regularDiscussionsByPosition[index].filter((d)=>!d.isForm);
        },
        visibleDiscussions (index) {
            if (this.allHidden) return this.discussionsByPosition[index].filter((d)=>d.isDraft);
            return this.discussionsByPosition[index];
        },
        setHidden (hidden) {
            this.hideableDiscussions.forEach((discussion)=>{
                if (hidden) this.store.collapseDiscussion(discussion);
                else this.store.expandDiscussion(discussion);
            });
        }
    }
};
